const MILLISECONDS_IN_DAY    = 86400000;
const MILLISECONDS_IN_HOUR   = 3600000;
const MILLISECONDS_IN_MINUTE = 60000;

export {
  MILLISECONDS_IN_DAY,
  MILLISECONDS_IN_HOUR,
  MILLISECONDS_IN_MINUTE,
};
